import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as Cookies from 'js-cookie';
import { ConstantsService as constants } from '../../services/constants/constants.service';
import { AlertBannerService, AlertType } from '../../lib/alert-banner';
import { OrganisationService } from '../../services/organisation/organisation.service';

@Component({
  selector: 'app-pulse-nps',
  templateUrl: './pulse-nps.component.pug',
  styleUrls: ['./pulse-nps.component.scss'],
  standalone: false
})
export class PulseNpsComponent implements OnInit, OnChanges {
  @Input() start!: any;
  @Input() end!: any;
  @Input() response_count: any;
  @Input() submitted_participants: any;
  @Input() participants_count: any;
  @Input() questionnaire = '';
  @Input() filterBy!: any;
  @Input() pause_load = false;
  @Input() request = '';
  @Input() survey = '';
  @Input() department = '';
  @Input() department_category = '';
  org_uid = Cookies.get(constants.ORG_COOKIE);
  org_brand_name: any;

  sectionLoading = true;
  private overallSectionLoaded = false;
  private trendSectionLoaded = false;
  private breakdownSectionLoaded = false;
  private countSectionLoaded = false;

  constructor(
    private organisationService: OrganisationService,
    private alertList: AlertBannerService
  ) {}

  ngOnInit(): void {
    // @ts-ignore
    this.organisationService.getOrganisation().subscribe(
        (res) => {
          this.org_brand_name = res.brand_name;
          },
          (err: any) => {
            console.log(err);
            this.alertList.append([
              {
                type: AlertType.DANGER,
                message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                keepOnRouteChange: true,
              },
            ]);
          }
      );
  }

  private checkAllSectionsLoaded(): void {
    if (
      !this.overallSectionLoaded ||
      !this.trendSectionLoaded ||
      !this.breakdownSectionLoaded ||
      !this.countSectionLoaded
    ) {
      return;
    }
    this.sectionLoading = false;
  }

  onOverallLoaded(): void {
    this.overallSectionLoaded = true;
    this.checkAllSectionsLoaded();
  }

  onTrendLoaded(): void {
    this.trendSectionLoaded = true;
    this.checkAllSectionsLoaded();
  }

  onBreakdownLoaded(): void {
    this.breakdownSectionLoaded = true;
    this.checkAllSectionsLoaded();
  }

  onCountLoaded(): void {
    this.countSectionLoaded = true;
    this.checkAllSectionsLoaded();
  }

  private resetSectionLoading(): void {
    this.overallSectionLoaded = false;
    this.trendSectionLoaded = false;
    this.breakdownSectionLoaded = false;
    this.countSectionLoaded = false;
    this.sectionLoading = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const inputs = ['start', 'end', 'request', 'survey', 'department'];
    const hasRelevantChange = inputs.some((key) => changes[key] && !changes[key].firstChange);
    if (hasRelevantChange && this.submitted_participants >= 15) {
      this.resetSectionLoading();
    }
  }
}
